// removed by extract-text-webpack-plugin
module.exports = {"preventScroll":"G2f032b","left":"G1aa9b6 G975a75","center":"Gc89208 Ge743c3","right":"G2f586a G75f68b"};